import { addStyles, DefaultTheme } from '../theme';

export const MDL = {
	container: 'mdl-button mdl-button--icon',
};

export const CSS = {
	container: 'c-Button',
	flip: 'c-Button--flip',
	isSmall: 'c-Button--is-small',
	icon: 'c-Button--icon',
};

const smallSize = DefaultTheme.space(6);
addStyles({
	[CSS.container]: {
		userSelect: 'none',
		color: DefaultTheme.font.color.supporting,

		// Overwrite MDL '!important' so 'a' tag does not default to a text cursor on hover
		['&[disabled]:hover']: {
			cursor: 'default !important',
		},
	},
	[CSS.flip]: {
		transform: 'translate(-12px,-12px) rotate(-90deg) !important',
	},
	[CSS.isSmall]: {
		width: smallSize,
		height: smallSize,
		'min-width': smallSize,
		'min-height': smallSize,
		'font-size': '80%',
	},
	[CSS.icon]: {
		'background-color': 'transparent',
	},
	// MDL centres icon-button glyphs with rules that name `.material-icons` literally, so Material Symbols
	// glyphs miss them and sit high and off-centre. Mirror both against the symbols class. `.mdl-button` is
	// `position: relative`, so the absolute centring is contained by the button as MDL intends.
	['mdl-button .material-symbols-outlined']: {
		'vertical-align': 'middle',
	},
	['mdl-button--icon .material-symbols-outlined']: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-12px, -12px)',
		'line-height': '24px',
		width: '24px',
	},
});
